import Cleave from 'cleave.js';

/**
 * Телефон. Например, +7 (982) 123-45-67
 */
[...document.querySelectorAll('.masked--phone')].forEach(function (field) {
    new Cleave(field, {
        numericOnly: true,
        prefix: '+7',
        blocks: [2, 3, 0, 3, 2, 2],
        delimiters: [" (", ")", " ", "-"]
    });
});

/**
 * Телефон без +, скобок и пробелов. Например, +79821234567
 */
[...document.querySelectorAll('.masked--phone-strict')].forEach(function (field) {
    new Cleave(field, {
        numericOnly: true,
        prefix: '+7',
        blocks: [12],
    });
});

/**
 * БИК Банка
 */
[...document.querySelectorAll('.masked--bank__bik')].forEach(function (field) {
    new Cleave(field, {
        numericOnly: true,
        blocks: [3, 3, 3]
    });
});

/**
 * ИНН Банка
 */
[...document.querySelectorAll('.masked--bank__inn')].forEach(function (field) {
    new Cleave(field, {
        numericOnly: true,
        blocks: [3, 3, 4]
    });
});

/**
 * КПП Банка
 */
[...document.querySelectorAll('.masked--bank__kpp')].forEach(function (field) {
    new Cleave(field, {
        numericOnly: true,
        blocks: [3, 3, 3]
    });
});

/**
 * ОГРН Банка
 */
[...document.querySelectorAll('.masked--bank__ogrn')].forEach(function (field) {
    new Cleave(field, {
        numericOnly: true,
        blocks: [3, 3, 3, 3, 3]
    });
});

/**
 * Корреспондентский счет Банка
 */
[...document.querySelectorAll('.masked--bank__correspondent-account')].forEach(function (field) {
    new Cleave(field, {
        numericOnly: true,
        blocks: [4, 4, 4, 4, 4]
    });
});

/**
 * Расчетный счет Банка
 */
[...document.querySelectorAll('.masked--bank__settlement-account')].forEach(function (field) {
    new Cleave(field, {
        numericOnly: true,
        blocks: [4, 4, 4, 4, 4]
    });
});

/**
 * Время
 */
[...document.querySelectorAll('.masked--time')].forEach(function (field) {
    new Cleave(field, {
        time: true,
        timePattern: ['h', 'm']
    });
});

/**
 * Ссылка на Инстаграм
 */
[...document.querySelectorAll('.masked--instagram')].forEach(function (field) {
    new Cleave(field, {
        prefix: 'https://instagram.com/'
    });
});

/**
 * Ссылка на вКонтакте
 */
[...document.querySelectorAll('.masked--vk')].forEach(function (field) {
    new Cleave(field, {
        prefix: 'https://vk.com/'
    });
});

/**
 * Ссылка на Youtube
 */
[...document.querySelectorAll('.masked--youtube')].forEach(function (field) {
    new Cleave(field, {
        prefix: 'https://www.youtube.com/watch?v='
    });
});

/**
 * Ссылка на Facebook
 */
[...document.querySelectorAll('.masked--fb')].forEach(function (field) {
    new Cleave(field, {
        prefix: 'https://facebook.com/'
    });
});

/**
 * Ссылка на WhatsApp
 */
[...document.querySelectorAll('.masked--whatsapp')].forEach(function (field) {
    new Cleave(field, {
        numericOnly: true,
        // prefix: 'https://api.whatsapp.com/send/?phone=+7',
        blocks: [12],
    });
});

/**
 * Ссылка на Одноклассники
 */
[...document.querySelectorAll('.masked--ok')].forEach(function (field) {
    new Cleave(field, {
        prefix: 'https://ok.ru/'
    });
});

/**
 * Ссылка на Telegram
 */
[...document.querySelectorAll('.masked--tg')].forEach(function (field) {
    new Cleave(field, {
        prefix: 'https://telegram.me/'
    });
});
